import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectLimitedActionInfo } from "../../selectors/selectLimitedActionInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { LimitedActionType } from "../../utils/network/generated/protoTypes";
import { utilLimitedActionTime } from "../../utils/utilLimitedActionTime";
import { FontWithOutline } from "../generic/font-with-outline/FontWithOutline";
import { TextLoca } from "../generic/text/TextLoca";
import { TimerCountdown } from "../generic/timer/TimerCountdown";
export var _WaterTowerTimer = function (_a) {
    var limitedActionInfo = _a.limitedActionInfo;
    return (React.createElement("div", { className: "water-tower-collection-text" },
        React.createElement(FontWithOutline, { style: IdStyles.TextBoldSecondaryOutline },
            React.createElement(TextLoca, { id: IdLoca.watertowerMenu_desc1 }),
            React.createElement(TimerCountdown, { remainingTime: utilLimitedActionTime.getResetTimestamp(limitedActionInfo) }))));
};
var mapState = function (state) {
    var limitedActionInfo = selectLimitedActionInfo(state, LimitedActionType.WATER_TOWER);
    return {
        limitedActionInfo: limitedActionInfo,
    };
};
export var WaterTowerTimer = connect(mapState)(_WaterTowerTimer);



//////////////////
// WEBPACK FOOTER
// ./src/features/watertower/WaterTowerTimer.tsx
// module id = 2806
// module chunks = 3